/* Buffelh page scripts: policy side menu (built from the H2 headings), FAQ anchors, notify form checks on the password page. */
(function () {
  'use strict';
  var doc = document.querySelector('[data-bx-doc]');
  var toc = document.querySelector('[data-bx-toc]');
  function slug(t) { return t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  if (doc && toc) {
    var hs = doc.querySelectorAll('h2');
    hs.forEach(function (h) {
      if (!h.id) h.id = slug(h.textContent);
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      toc.appendChild(a);
    });
    if (!hs.length) toc.hidden = true;
  }
  function openTarget() {
    var id = location.hash.slice(1);
    if (!id) return;
    var el = document.getElementById(id);
    if (el && el.tagName === 'DETAILS') el.open = true;
  }
  window.addEventListener('hashchange', openTarget);
  openTarget();
})();
